import { useActionCable } from './useActionCable'
import { useFaye } from './useFaye'

/**
 * Unified realtime hook — delegates to ActionCable or Faye
 * based on window.REALTIME_BACKEND injected by Rails layout.
 * Toggle via ENV var REALTIME_BACKEND=faye (no rebuild needed).
 */
export const useRealtime = (fiscodex, onMessage) => {
  const backend = window.REALTIME_BACKEND || 'anycable'

  // Both hooks must always be called (Rules of Hooks).
  // Pass null to whichever is inactive — both handle null as a no-op.
  const acResult = useActionCable(backend === 'anycable' ? fiscodex : null, onMessage)
  const fayeResult = useFaye(backend === 'faye' ? `/messages/${fiscodex}` : null, onMessage)

  return backend === 'faye' ? fayeResult : acResult
}
